module.exports = __webpack_public_path__ + "static/media/photo12.cd6689a9.jpg";